import { type SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';

import { fetchRecurrentPaymentsSaga } from './fetch-recurrent-payments';
import { unsubscribeApplicationSaga } from './unsubscribe-application';

export function* applicationsSagas(): SagaIterator {
  yield all([fork(fetchRecurrentPaymentsSaga), fork(unsubscribeApplicationSaga)]);
}
